module.exports = __webpack_public_path__ + "static/img/banner.d976c4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/hatchya/banner.jpg
// module id = M95u
// module chunks = 1